import { DisplayOption } from '~/types/DisplayOptions';

export const useGetDisplayOptionsClasses = (displayOptions?: DisplayOption[]) => {
  const classes = {};

  if (displayOptions) {
    displayOptions.forEach((displayOption) => {
      if (displayOption?.fields?.type === 'style') {
        const fieldName = getProperElement(displayOption.fields);
        if (classes.hasOwnProperty(fieldName)) {
          classes[fieldName] += ' ' + displayOption.fields.value;
        } else {
          classes[fieldName] = displayOption.fields.value;
        }
      }
    });
  }

  return classes;
};

const getProperElement = (fields) => {
  switch (fields.scope) {
    case 'title':
      return 'title';
    case 'block':
      return 'block';
    case 'description':
      return 'description';
    case 'background':
      return 'background';
    case 'image':
      return 'image';
    case 'item-text':
      return 'itemtext';
    default:
      return 'container';
  }
};
